module.exports = __webpack_public_path__ + "img/PlaceHolderPortrait.a1199661.png";